import React, { Fragment } from 'react';
import { TeamForm, refetchTable } from '@kineticdata/react';
import { compose, withHandlers } from 'recompose';
import { FormComponents, addToast } from '@kineticdata/bundle-common';
import { PageTitle } from '../shared/PageTitle';
import { Link } from '@reach/router';

const TeamEditComponent = ({
  formKey,
  slug,
  handleSave,
  handleDelete,
  appLocation,
}) => (
  <div className="page-container page-container--panels">
    <TeamForm
      formKey={formKey}
      teamSlug={slug}
      components={{
        FormError: FormComponents.FormError,
        FormButtons: FormComponents.generateFormButtons({
          handleDelete,
          submitLabel: 'Update Team',
          cancelPath: '..',
          components: { Link },
        }),
      }}
      alterFields={{
        description: {
          component: FormComponents.TextAreaField,
        },
      }}
      onSave={handleSave}
    >
      {({ form, bindings: { team, values }, initialized }) =>
        initialized && (
          <Fragment>
            <div className="page-panel">
              <PageTitle
                parts={[`Edit Team`, 'Teams']}
                breadcrumbs={[{ label: 'Teams', to: '..' }]}
                title={team && team.get('name')}
              />
              <div className="form-unstyled mb-5">{form}</div>
            </div>
          </Fragment>
        )
      }
    </TeamForm>
  </div>
);

// TODO implement handleDelete?
export const TeamEdit = compose(
  withHandlers({
    handleSave: props => () => team => {
      refetchTable(props.tableKey);
      addToast(`${team.name} updated successfully.`);
    },
  }),
)(TeamEditComponent);
